/**
 * Regras do envio de VÁRIOS anexos de uma vez (decisões do dono, 16/out/2026):
 *  - no máximo 10 arquivos por envio;
 *  - o texto digitado vira legenda só do ÚLTIMO arquivo — os outros vão sem
 *    (22/out/2026; antes era o primeiro).
 */

/** Teto de arquivos por envio — evita rajada grande mandada por engano. */
export const MAX_ANEXOS = 10;

/**
 * Quantos dos arquivos novos ainda cabem, dado quantos já estão anexados.
 * Os que passam do teto ficam de fora (quem chama avisa).
 */
export function quantosCabem(
  jaAnexados: number,
  novos: number,
): { aceitos: number; recusados: number } {
  const livres = Math.max(0, MAX_ANEXOS - jaAnexados);
  const aceitos = Math.min(livres, novos);
  return { aceitos, recusados: novos - aceitos };
}

/**
 * Onde vai a legenda. Regra: no último arquivo — mas áudio não leva legenda
 * (a Meta recusa), então volta pro último que aceita (imagem, vídeo ou
 * documento). Se TODOS forem áudio, o texto não se perde: vai como mensagem
 * de texto separada, antes dos áudios.
 *
 * Devolve o índice que leva a legenda (-1 = nenhum) e o texto que precisa
 * sair sozinho (null = nenhum).
 */
export function ondeVaiALegenda(
  tipos: ReadonlyArray<'image' | 'audio' | 'video' | 'document'>,
  legenda: string,
): { indice: number; textoSeparado: string | null } {
  if (!legenda) return { indice: -1, textoSeparado: null };
  let indice = -1;
  for (let i = tipos.length - 1; i >= 0; i--) {
    if (tipos[i] !== 'audio') {
      indice = i;
      break;
    }
  }
  if (indice === -1) return { indice: -1, textoSeparado: tipos.length > 0 ? legenda : null };
  return { indice, textoSeparado: null };
}
